export default __webpack_public_path__ + "static/media/Payment01.1ed04b01.png";